import React from 'react';
import { BackButton } from '../../../../components';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { Block } from '../../../../../../components';
import { CheckboxInput } from './components/CheckboxList';
import QuitPageModal from '../../CertificateOfStudies/dialogs/QuitPageModal';
import {
  TextTitle,
  ToggleHeader
} from '../../../certificates-constancies/type1/register/components';
import { ProcedureInfoComponent } from '../info/components/ProcedureinfoComponent';
import Step from '../../UpdatePhoto/Register/components/Step';
import { SaveButton } from '../../../scholarships/bse/components/styled';
import { Container } from '../info/components/styled';
import AlertComponent from './components/AlertComponent';
import Processing from '@/presentation/components/Processing';
import IDHelper from '@/core/helpers/IDHelper';
import Tooltip from '@/presentation/reusables/Tooltip';
import { TooltipContainer } from './components/styled';
import Link from '@/presentation/reusables/Link';

interface Props {
  procedureSelectedInfo: any;
  totalItems: any[];
  selectedItems: string[];
  open: {
    openBack: boolean;
    setOpenBack: (value: boolean) => void;
  };
  handleOnChange: (value: string) => void;
  isDisabled: (value: string) => void;
  handlerBackButton: () => void;
  handleRegister: () => void;
  isRegistering: boolean;
}

const RetreatCourseRegisterView: React.FC<Props> = (props) => {
  const {
    procedureSelectedInfo,
    totalItems,
    open,
    selectedItems,
    handlerBackButton,
    isRegistering
  } = props;
  const { handleOnChange, isDisabled, handleRegister } = props;
  const { openBack, setOpenBack } = open;

  const isRetreatPeriod = () => {
    if (procedureSelectedInfo?.hasFinishedCourses) return false;
    return selectedItems.length >= totalItems.length - 1;
  };

  return (
    <ContainerProcedure>
      <Processing isOpen={isRegistering} />
      <BackButton onClick={() => setOpenBack(true)} />
      <div style={{ marginTop: '16px' }} />
      <SubContainer>
        <ToggleHeader
          name={procedureSelectedInfo?.name}
          amount={procedureSelectedInfo?.amount}
          duration={procedureSelectedInfo?.duration}
          date={procedureSelectedInfo?.endDate}
          childContent={
            <ProcedureInfoComponent
              inRegister
              detail={procedureSelectedInfo?.detail}
            />
          }
        />
        <TextTitle title="Progreso" />
        <Block customized padding="28px 0px 45px 8px">
          <Step name={'Registrar solicitud'} order={1}>
            <Container>
              <p style={{ marginBottom: 12, fontSize: 14, color: '#161D1F' }}>
                {'Selecciona los cursos de los que deseas retirarte. '}
              </p>
              <p style={{ marginBottom: 12, fontSize: 14, color: '#161D1F' }}>
                Recuerda, debes mantener al menos un curso y no puedes retirarte
                de aquellos que ya tengan una nota final.
              </p>

              {/* Si es CGT (tiene cursos modulares) */}
              {procedureSelectedInfo?.detail?.datesModule?.length > 1 && (
                <TooltipContainer>
                  <Tooltip width="256px" boxToRight>
                    <ul>
                      <li>M1 = Módulo 1</li>
                      <li>M2 = Módulo 2</li>
                      <li>BM = Bimodular</li>
                    </ul>
                  </Tooltip>
                  <span style={{ color: 'var(--text-primary)' }}>
                    {' '}
                    ¿Qué es M1, M2 y BM?
                  </span>
                </TooltipContainer>
              )}

              {totalItems?.map((item) => (
                <>
                  {!item?.courses ? (
                    <CheckboxInput
                      key={item?.id}
                      value={item?.name}
                      handleOnChange={() => handleOnChange(item)}
                      disabled={isDisabled(item)}
                      typeCourse={item?.CodigoEstado}
                    />
                  ) : (
                    <CheckboxInput
                      key={item?.courses[0].id}
                      value={item}
                      handleOnChange={() => handleOnChange(item)}
                      disabled={isDisabled(item)}
                      relatedCourses
                      typeCourse={item?.CodigoEstado}
                    />
                  )}
                </>
              ))}
              {isRetreatPeriod() && (
                <AlertComponent>
                  Para retirarte de todos los cursos, debes realizar{' '}
                  <Link
                    linkType="internal"
                    url={`/tramites/ticketera/registro?v=TA0052`}
                    linkName="Retiro de periodo lectivo"
                  />
                </AlertComponent>
              )}
              {selectedItems?.map((item: any) => (
                <div style={{ marginTop: '16px' }} key={IDHelper.generateID()}>
                  {item?.courses && (
                    <AlertComponent>
                      Recuerda que los cursos teóricos con laboratorio se
                      retiran juntos.
                    </AlertComponent>
                  )}
                </div>
              ))}
              <SaveButton
                style={{
                  marginTop: 16
                }}
                onClick={handleRegister}
                type="button"
                data-testid="btn-register-retreatCourse"
                disabled={!(selectedItems.length > 0)}
              >
                Siguiente
              </SaveButton>
            </Container>
          </Step>
          <Step name={'Realizar Pago'} order={2} disabled>
            <p> </p>
          </Step>
          <Step name={'Estado solicitud'} order={3} isLast disabled>
            <p> </p>
          </Step>
        </Block>
      </SubContainer>
      <QuitPageModal
        handlerBack={handlerBackButton}
        handlerClose={() => setOpenBack(false)}
        show={openBack}
      />
    </ContainerProcedure>
  );
};

export default RetreatCourseRegisterView;
